<template>
  <div id="account">

    <a-row :gutter="20">
      <a-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5">
        <div style="width: 100%">
          <!-- <a-button type="primary" @click="toggleCollapsed" style="margin-bottom: 16px">
            <a-icon :type="collapsed ? 'menu-unfold' : 'menu-fold'" />
          </a-button> -->
          <a-menu :defaultSelectedKeys="['1']" :defaultOpenKeys="['sub1']" mode="inline" :inlineCollapsed="collapsed">
            <a-menu-item v-if="!item.items && !item.hide" v-for="(item, index) in items" :key="index" @click="changeTab(item.link)">
              <a-icon type="appstore" />
              <span>{{ item.title }}</span>
            </a-menu-item>
            <a-sub-menu v-if="item.items && !item.hide" v-for="(item, index) in items" :key="index" @click="changeTab(item.link)">
              <span slot="title">
                <a-icon type="appstore" /><span>{{ item.title }}</span></span>
              <a-menu-item v-for="child in item.items" :key="child.title" @click="changeTab(child.link, child.id, child.outLink)">{{ child.title }}</a-menu-item>
            </a-sub-menu>
          </a-menu>
        </div>
      </a-col>
      <a-col :xs="24" :sm="24" :md="19" :lg="19" :xl="19">
        <div v-if="this.userInfo.data">
          <!-- 我的投資 -->
          <div v-if="this.currentTab === 'myInvest'">
            <my-invest :fundSum="fundSum" :currentTab="'myInvest'" :id="this.userInfo.data.id" :is_active="userInfo.data.is_active" :passed="userInfo.data.passed" />
          </div>
          <!-- 房產投資 -->
          <div v-if="this.currentTab === 'homeInvest'">
            <home-invest :country="country" :is_active="userInfo.data.is_active" :passed="userInfo.data.passed" />
          </div>
          <!-- 旅遊產品 -->
          <!-- <div v-if="this.currentTab === 'travel'"> -->
          <!-- <travel :country="country" /> -->
          <!-- </div> -->
          <!-- 风险测评 -->
          <div v-if="this.currentTab === 'riskTest' && this.userInfo.data.is_active === null">
            <risk-test :login_type="userInfo.data.login_type" :id="this.userInfo.data.id" />
          </div>

          <!-- 基金投資 -->
          <div v-if="this.currentTab === 'fundInfo'">
            <fund-info :route_id="route_id" :is_active="userInfo.data.is_active" :passed="userInfo.data.passed" />
          </div>
          <!-- 合格投资人认证 -->
          <div v-if="this.currentTab === 'verify' && this.userInfo.data.passed !== 'pass'">
            <verify :id="this.userInfo.data.id" />
          </div>
          <!-- 帐户管理 -->
          <div v-if="this.currentTab === 'account'">
            <account />
          </div>
        </div>
      </a-col>
    </a-row>

    <v-snackbar :bottom="y === 'top'" :color="color" :left="x === 'left'" :right="x === 'right'" :timeout="6000" :top="y === 'top'" v-model="snackbar">
      <div>{{ text }}</div>
    </v-snackbar>
  </div>
</template>

<script>
import RiskTest from '@/components/RiskTest.vue'
import FundInfo from '@/components/FundInfo.vue'
import Account from '@/components/Account.vue'
import MyInvest from '@/components/MyInvest.vue'
import Verify from '@/components/Verify.vue'
import HomeInvest from '@/components/HomeInvest.vue'
import Travel from '@/components/Travel.vue'
import Cookies from 'js-cookie'
import { mapGetters } from 'vuex'

export default {
  components: {
    RiskTest,
    FundInfo,
    Account,
    MyInvest,
    Verify,
    HomeInvest,
    Travel
  },
  data() {
    return {
      collapsed: false,
      fundSum: 0,
      drawer: null,
      snackbar: false,
      y: 'top',
      x: null,
      mode: '',
      timeout: 6000,
      text: '',
      color: '',
      valid: false,
      items: [
        {
          link: 'myInvest',
          title: '我的投资',
          hide: false
        },
        {
          link: 'fundInfo',
          title: '基金投资',
          items: [],
          hide: true
        },
        {
          link: 'homeInvest',
          title: '房产投资',
          items: [
            {
              id: 'Europe',
              link: 'homeInvest',
              title: '欧洲'
            },
            {
              id: 'Australia',
              link: 'homeInvest',
              title: '澳洲'
            }
          ],
          hide: false
        },
        {
          // http://www.canaan-overseas.com
          title: '旅游产品',
          items: [],
          hide: false
        },
        {
          link: 'riskTest',
          title: '风险测评',
          hide: true
        },
        {
          link: 'verify',
          title: '合格投资人认证',
          hide: true
        },
        {
          link: 'account',
          title: '帐户管理',
          hide: false
        }
      ],
      currentTab: 'myInvest',
      route_id: '',
      country: ''
    }
  },
  computed: mapGetters({
    fundInfo: 'fundInfo',
    saleFundInfo: 'saleFundInfo',
    catelog: 'catelog',
    userInfo: 'userInfo',
    announceByUser: 'announceByUser',
    travel: 'travel'
  }),
  created() {
    if (Cookies.get('member_id')) {
      this.$store
        .dispatch('MemberLogin', { token: Cookies.get('member_id') })
        .then(() => {
          if (this.userInfo.data) {
            this.isLogin = true

            this.$store
              .dispatch('GetFundInfoByUser', this.userInfo.data)
              .then(() => {
                this.fundInfo.data.map(item => {
                  this.fundSum += Number(item.price)

                  this.items[1].items.push({
                    title: item.title,
                    link: `fundInfo`,
                    id: item.id
                  })
                })
              })
            this.$store
              .dispatch('GetSaleFundInfoByUser', this.userInfo.data)
              .then(() => {
                this.saleFundInfo.data.map(item => {
                  this.fundSum += Number(item.price)

                  this.items[1].items.push({
                    title: item.title,
                    link: `fundInfo`,
                    id: item.id
                  })
                })

                this.items[5].hide = this.userInfo.data.passed === 'pass' ? true : false // 合格投資人
                this.items[4].hide = this.userInfo.data.is_active ? true : false // 風險評測
                if (
                  this.userInfo.data.is_active === '1' &&
                  this.userInfo.data.passed === 'pass'
                ) {
                  this.items[1].hide = false
                }
              })
            this.$store.dispatch('GetAnnounceByUser', this.userInfo.data)
          }
        })
    } else {
      this.dialog = true
      window.location.href = '/'
    }
    this.fetchData()
  },
  methods: {
    changeTab(link, id, outLink) {
      if (id) {
        if (id === 'Europe' || id === 'Australia') {
          this.country = id
        } else {
          this.route_id = id
        }
        if (outLink === 'travel') {
          // this.country = id
          window.open('http://www.canaan-overseas.com', '_blank')
        }
      }
      this.currentTab = link
    },
    fetchData() {
      this.$store.dispatch('getTravel').then(() => {
        this.travel.data.map(item => {
          this.items[3].items.push({
            title: item.contry,
            link: this.currentTab,
            outLink: `travel`,
            id: item.id
          })
        })
      })
    },
    toggleCollapsed() {
      this.collapsed = !this.collapsed
    }
  }
}
</script>

<style lang="scss" scoped>
#account {
  position: relative;
  height: 100%;
}
.menu-title {
  font-size: 18px;
}
</style>